module.exports = __webpack_public_path__ + "img/pic_usa_04.de1ace3c.jpg";